import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"





function BraceletsPage({categoryType}) {
  return (

    <CollectionMainPage categoryType={categoryType}/>
  )
}

export default BraceletsPage